module.exports = __webpack_public_path__ + "img/9.92cc6b00.png";